import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraSectionHeader, SpecraText, specraButtonVariants } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { Link } from 'react-router-dom';
import { useTenantAreas } from '../../lib/access/useTenantAreas';
const ASK = {
    title: 'Ask Assist a question about a document or a contract',
    detail: 'Assist reads what you upload and answers with the page it found it on.',
    verb: 'Ask Assist',
    href: '/assistant'
};
const UPLOAD = {
    title: 'Upload a document',
    detail: 'A solicitation, a SOW or a contract. It is read in the background and appears in Documents.',
    verb: 'Upload',
    href: '/documents/upload'
};
const REGISTRIES = {
    title: 'Look up a company or a vehicle in Registries',
    detail: 'The shared catalogs of companies, contacts, vehicles and labor categories.',
    verb: 'Open Registries',
    href: '/registries'
};
export function GettingStarted() {
    const areas = useTenantAreas();
    const steps = [
        ASK,
        UPLOAD,
        ...areas.registries ? [
            REGISTRIES
        ] : []
    ];
    return /*#__PURE__*/ _jsxs("section", {
        className: "space-y-2",
        "data-testid": Testids.dashboard.gettingStarted,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-wrap items-baseline justify-between gap-2",
                children: [
                    /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                        headingAs: "h2",
                        title: "Getting Started",
                        variant: "group"
                    }),
                    /*#__PURE__*/ _jsxs(SpecraText, {
                        size: "meta",
                        tone: "muted",
                        children: [
                            steps.length === 3 ? 'Three things' : 'Two things',
                            " you can do with the access you have"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("ol", {
                className: "divide-y divide-border border-y border-border",
                children: steps.map((s, i)=>/*#__PURE__*/ _jsxs("li", {
                        className: "flex items-center gap-[var(--space-3)] py-[var(--space-3)]",
                        "data-testid": Testids.dashboard.gettingStartedStep,
                        children: [
                            /*#__PURE__*/ _jsx(SpecraText, {
                                "aria-hidden": "true",
                                className: "flex size-6 shrink-0 items-center justify-center rounded-full border border-border",
                                size: "meta",
                                tone: "muted",
                                children: i + 1
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "min-w-0 flex-1",
                                children: [
                                    /*#__PURE__*/ _jsx(SpecraText, {
                                        as: "div",
                                        className: "font-medium",
                                        size: "body-sm",
                                        children: s.title
                                    }),
                                    /*#__PURE__*/ _jsx(SpecraText, {
                                        as: "div",
                                        size: "body-ui",
                                        tone: "muted",
                                        children: s.detail
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Link, {
                                className: specraButtonVariants({
                                    variant: i === 0 ? 'default' : 'secondary',
                                    size: 'sm'
                                }),
                                to: s.href,
                                children: s.verb
                            })
                        ]
                    }, s.href))
            })
        ]
    });
}
